import React, {Component} from 'react';
import {Button, Form, Input,Segment,Grid,Search} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";

const uuidv1 = require('uuid/v1');


class AddNewKey extends Component {

    constructor(props) {
        super(props);
        this.state = {
            noOfKeys: 0,
            keyDescription: " ",
            COnoOfKeys:0
        }
    }

    handleSubmit = async () => {
        this.setState({isCreating:true});
        const inspectionType = this.props.reportDetails['inspection_type'];
        let keyObj = {};
            keyObj = {
                action: 'create',
                client_id: uuidv1(),
                ci_description: this.state.keyDescription,
                ci_no_of_keys: this.state.noOfKeys,
                co_description: this.state.keyDescription,
                co_no_of_keys: this.state.COnoOfKeys,
                images: []
            };

        await this.props.addNewKeyIntoReport(keyObj);
          if((this.state.noOfKeys > this.state.COnoOfKeys) && this.props.reportDetails['inspection_type'] == "co"){
                window.alert("This key's CO quantity is less than its CI quantity, please remember to add this as a Teannt Cost on the Tenant Cost General Note")
            }
        this.setState({isCreating:false,noOfKeys:0,COnoOfKeys:0,keyDescription:" "});
    };

    render() {

        let keyOptions =  [
                                        { title: 'Yale, Front Door' },
                                        { title: 'Chubb, Front Door' },
                                        { title: 'Fob, Front Door' },
                                        { title: 'Yale, Back Door' },
                                        { title: 'Chubb, Back Door' },
                                        { title: 'Yale, Mailbox' },
                                    ]
        return (<Segment style={{margin: "20px auto 0 auto",maxWidth:"600px"}}>
            <Form  onSubmit={this.handleSubmit}>
                <Form.Group widths='equal'>
                    <Form.Field>
                        <label>Type & Usage</label>
                        <Search
                            className="key-search"
                            placeholder="Key Type & Usage"
                            onSearchChange={(e, { value }) => { this.setState({ keyDescription: value }); }}
                            onResultSelect={(e, { result }) => { this.setState({ keyDescription: result.title }); }}
                            results={this.state.keyDescription != " " ? keyOptions.filter(key =>{return key.title.toLowerCase().includes(this.state.keyDescription.toLowerCase())}):keyOptions}
                            value={this.state.keyDescription}
                            input={{ required: true }} // passes props to underlying input
                        />
                    </Form.Field>
                  { (this.props.reportDetails['inspection_type'] != "co" || this.props.reportDetails.report_type == "other") &&  <Form.Field>
                        <label>CI No. of Keys</label>
                        <Input
                            type="number"
                            placeholder="CI No. Of Keys"
                            required
                            ref="keyDesc"
                            value={this.state.noOfKeys}
                            onFocus={(e) => {
                                this.setState({noOfKeys: e.target.value});
                            }}
                            onChange={(e) => {
                                this.setState({noOfKeys: e.target.value});
                            }}
                        />
                    </Form.Field>}
                    {  this.props.reportDetails['inspection_type'] == "co" && <Form.Field>
                        <label>CO No. of Keys</label>
                        <Input
                            type="number"
                            placeholder="CO No. Of Keys"
                            required
                            ref="coKeyDesc"
                            value={this.state.COnoOfKeys}
                            onChange={(e) => {
                                this.setState({COnoOfKeys: e.target.value});
                            }}
                        />
                    </Form.Field>}
                </Form.Group>
                                    <div style={{textAlign:"center"}}>
                    <Button type="submit" content="Add" primary disabled={this.state.isCreating}/></div>
        </Form></Segment>);
    }
}

export default ReportContainer(AddNewKey);


// WEBPACK FOOTER //
// ./src/views/report/add_new_key.js